import React from 'react';
import { Badge } from '../design-system';

export interface StrategyAutomationBadgeProps {
  aiEnabled?: boolean | null;
  className?: string;
}

export default function StrategyAutomationBadge({
  aiEnabled,
  className,
}: StrategyAutomationBadgeProps): React.ReactElement | null {
  if (typeof aiEnabled !== 'boolean') {
    return null;
  }

  return (
    <Badge
      className={className}
      data-ai-enabled={aiEnabled ? 'true' : 'false'}
      title={aiEnabled
        ? 'This strategy uses AI decision making'
        : 'This strategy uses rules-based decision making'}
      variant={aiEnabled ? 'info' : 'neutral'}
    >
      {aiEnabled ? 'AI-powered' : 'Rules-based'}
    </Badge>
  );
}
